"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.answersToSend = exports.ConcernFormFieldsQuestionsIndex = exports.ConcernFormFields = void 0;
/* istanbul ignore file */ let ConcernFormFields = exports.ConcernFormFields = /*#__PURE__*/ function(ConcernFormFields) {
    ConcernFormFields["TextAreaFieldInput1"] = "textAreaFieldInput1";
    ConcernFormFields["TextAreaFieldInput2"] = "textAreaFieldInput2";
    ConcernFormFields["TextAreaFieldInput3"] = "textAreaFieldInput3";
    ConcernFormFields["RadioButtonFieldInput4"] = "radioButtonFieldInput4";
    ConcernFormFields["RadioButtonFieldInput5"] = "radioButtonFieldInput5";
    ConcernFormFields["RadioButtonFieldInput6"] = "radioButtonFieldInput6";
    ConcernFormFields["TextFieldInput7"] = "textFieldInput7";
    ConcernFormFields["TextAreaFieldInput9"] = "textAreaFieldInput9";
    ConcernFormFields["Recaptcha"] = "recaptcha";
    return ConcernFormFields;
}({}); // Fields can come in different order and some need to be skipped
const ConcernFormFieldsQuestionsIndex = exports.ConcernFormFieldsQuestionsIndex = {
    [ConcernFormFields.TextAreaFieldInput1]: 0,
    [ConcernFormFields.TextAreaFieldInput2]: 1,
    [ConcernFormFields.TextAreaFieldInput3]: 2,
    [ConcernFormFields.RadioButtonFieldInput4]: 3,
    [ConcernFormFields.RadioButtonFieldInput5]: 4,
    [ConcernFormFields.RadioButtonFieldInput6]: 5,
    [ConcernFormFields.TextFieldInput7]: 6,
    [ConcernFormFields.TextAreaFieldInput9]: 8
};
const answersToSend = exports.answersToSend = [
    ConcernFormFields.TextAreaFieldInput1,
    ConcernFormFields.TextAreaFieldInput2,
    ConcernFormFields.TextAreaFieldInput3,
    ConcernFormFields.RadioButtonFieldInput4,
    ConcernFormFields.RadioButtonFieldInput5,
    ConcernFormFields.RadioButtonFieldInput6,
    ConcernFormFields.TextFieldInput7,
    ConcernFormFields.TextAreaFieldInput9
];
